import Vue from 'vue'

const getDefaultState = () => {
    return {
        snackbar: {
            visible: false,
            timeout: '-1',
            text: null,
            data: null,
            type: 'error',
        },
    }
}

const state = getDefaultState()

const getters = {
    snackbar(state: any) {
        return state.snackbar
    },
}

const mutations = {
    // Pass error object
    setGeneralErrorSnackBar(state: any, payload: any) {
        let title = payload?.response?.data?.errors || null

        console.log('setGeneralErrorSnackBar', payload)
        state.snackbar = {
            visible: true,
            timeout: '-1',
            title: title,
            type: 'error',
        }
    },

    setErrorSnackBar(state: any, payload: any) {
        state.snackbar = {
            visible: true,
            timeout: '-1',
            ...payload,
            type: 'error',
        }
    },

    setSuccessSnackBar(state: any, payload: any) {
        state.snackbar = {
            visible: true,
            timeout: payload.timeout ? payload.timeout : '-1',
            ...payload,
            type: 'success',
        }
    },

    closeSnackbar(state: any) {
        Vue.set(state.snackbar, 'visible', false)
    },

    //RESET
    resetSnackbar(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
